import request from '@/router/axios';
import { baseUrl } from '@/config/env';
export const loginByUsername = (username, password, imageCode, rememberMe) => request({
    url: '/api/login',
    method: 'post',
    meta: {
        isToken: false
    },
    data: {
        username,
        password,
        imageCode,
        rememberMe
    }
})

export const  registerUsername = (phone, pass_word, smsCode) => request({
  url: '/userRegister',
  method: 'post',
  meta: {
    isToken: false
  },
  data: {
    phone,
    pass_word,
    smsCode,
  }
})

export const getUserInfo = () => request({
    url:  '/user/getUserInfo',
    method: 'get'
});

export const refeshToken = () => request({
    url: baseUrl + '/user/refesh',
    method: 'post'
})

export const getMenu = (type = 0) => request({
    url: '/user/getMenu/false',
    method: 'get',
    data: {
        type
    }
});

export const getMenuAll = () => request({
    url: '/user/getMenu/true',
    method: 'get',
    data: {
        type: 0
    }
});
export const getSysMenuInfo = () => request({
    url: '/user/sysMenuInfo',
    method: 'get',
    data: {
        type: 0
    }
});

export const getTableData = (param) => request({
    url: '/restful/'+param.entity+'/index',
    method: 'POST',
    data: {
        limit:param.limit,
        param:param.param
    }
});

export const getTopMenu = () => request({
    url: baseUrl + '/user/getTopMenu',
    method: 'get'
});

export const sendLogs = (list) => request({
    url: baseUrl + '/user/logout',
    method: 'post',
    data: list
})
export const svaeUser = (param) => request({
    url: '/restful/SysUser/save',
    method: 'POST',
    data:  param
});

export const updateUser = (param) => request({
    url: '/user/sveUser',
    method: 'POST',
    data: param
});

export const deleteUser = (param) => request({
    url: '/restful/SysUser/deleteById/' + param.id,
    method: 'get',
    data: { }
});
export const logout = () => request({
    url: '/api/logout',
    meta: {
        isToken: false
    },
    method: 'get'
})



// WEBPACK FOOTER //
// ./src/api/user.js